import { WriteRequest } from "~/backendApis/foundation/WriteRequest"
import { ApiClient } from "~/backendApis/foundation/ApiClient"
import { UploadedFileResponse } from "~/backendApis/viewModel/file"

interface Params {
  file: Blob
}

export class UploadMatchingFileWriteRequest extends WriteRequest<UploadedFileResponse> {
  private readonly endpoint = "/file/matching/file/upload"
  private readonly params: Params

  constructor(params: Params) {
    super()
    this.params = params
  }

  public post(): Promise<UploadedFileResponse> {
    const formData = new FormData()
    formData.append("file", this.params.file)

    return this.apiClient.post(
      this.endpoint,
      formData,
      ApiClient.MULTIPART_CUSTOM_HEADER
    )
  }
}
